export const yesOrNoOptions = [
  { text: 'Yes', value: true },
  { text: 'No', value: false },
];
